<template>
  <component :is="tag">
    <template v-if="value">{{value | moment('timezone', 'Europe/Minsk', format)}}</template>
    <template v-else>{{$t(placeholder)}}</template>
  </component>
</template>

<script>
  export default {
    props: {
      value: [Date, Number],
      date: {
        type: Boolean,
        default: true
      },
      time: {
        type: Boolean,
        default: true
      },
      tz: {
        type: Boolean,
        default: true
      },
      tag: {
        type: String,
        default: 'p'
      },
      placeholder: {
        type: String,
        default: 'labels.date-not-specified'
      }
    },

    computed: {
      format() {
        const parts = [];

        if (this.date) {
          parts.push('DD.MM.YYYY');
        }

        if (this.time) {
          parts.push('HH:mm');
        }

        if (this.time && this.tz) {
          parts.push('(\\G\\M\\TZ)');
        }

        return parts.join(' ');
      }
    }
  }
</script>

<style scoped>

</style>
